<template>
  <el-dialog
    :visible="visible"
    title="方案修改"
    class="combo-dialog"
    @opened="afterOpen"
    @close="onClose"
    width="1300px"
    top="5vh"
  >
    <div class="search-header">
      <el-radio-group v-model="searchData.comboType" class="combo-type-radio">
        <el-radio-button
          v-for="(item, index) in tabs"
          :key="index"
          :label="item.value"
        >
          {{ item.name }}
        </el-radio-button>
      </el-radio-group>

      <div class="period-select">
        <span class="period-label">通道：</span>
        <el-select v-model="searchData.comboRoute" placeholder="请选择通道" class="period-select-input">
          <el-option
              v-for="(item, index) in dict.ComboRouteList"
              :key="index"
              :label="item.name"
              :value="item.value"
          />
        </el-select>
      </div>

      <div class="period-select">
        <span class="period-label">期数：</span>
        <el-select 
          v-model="currBillNum" 
          placeholder="请选择期数"
          class="period-select-input"
        >
          <el-option
            v-for="(item, index) in billNumList"
            :key="index"
            :label="item+ ' 期'"
            :value="item"
          />
        </el-select>
      </div>
    </div>

    <div class="dialog-save">
      <el-button type="primary" @click="onSubmit" class="save-btn">保 存</el-button>
    </div>

    <div class="combo-body">
      <div class="grade-list">
        <div
          v-for="(item, index) in groupedList"
          :key="item.grade.value"
          class="grade-group"
          :style="getGradeGroupStyle(item.grade.value, index)"
        >
          <div 
            class="grade-name" 
            :style="getGradeNameStyle(item.grade.value)"
          >
            {{ item.grade.name }}
          </div>
          <div class="combo-list">
            <div v-if="index > 0" class="divider" />
            <combo-card
              v-for="combo in item.list"
              :value="combo"
              :key="combo.comboId"
              :checked="form.comboId === combo.comboId"
              @checkedChange="onCheckedChange(combo.comboId)"
            />
          </div>
        </div>
      </div>
      <el-form
        v-if="searchData.comboType === dict.EnumComboType.CUSTOM"
        ref="form"
        :model="form"
        label-width="50px"
        inline
        class="custom-form"
      >
        <el-form-item label="备注">
          <el-input 
            v-model="form.remark" 
            placeholder="请输入备注信息" 
            class="remark-input"
            clearable
          />
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import {
  ComboGradeList,
  EnumComboType,
  ComboGradeToColorMap,
  ComboTypeForReviewList,
  EnumComboRoute,
  ComboRouteList,
} from "@/enum/dict/index.js";

import ComboCard from "./combo-card.vue";
import { getStoreComboList, editStoreComboList } from "../api.js";

export default {
  name: "EditCombo",
  components: { ComboCard },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    orderNo: {
      type: String,
      required: false,
      default: null,
    },
    comboId: {
      type: Number,
      required: false,
      default: null,
    },
    comboRoute: {
      type: Number,
      required: false,
      default: EnumComboRoute.ROUTE_1,
    },
    rewardComboNum: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      searchData: {
        comboType: EnumComboType.COMMON,
        comboRoute: EnumComboRoute.ROUTE_1,
      },
      form: {
        remark: undefined,
        comboId: undefined,
      },
      list: [],
      currBillNum: undefined,
      billNumList: [],
      dict: {
        ComboGradeList,
        EnumComboType,
        ComboGradeToColorMap,
        ComboTypeForReviewList,
        EnumComboRoute,
        ComboRouteList,
      },
    };
  },
  computed: {
    tabs() {
      return this.dict.ComboTypeForReviewList;
    },
    groupedList() {
      let count = 0;
      const comboList = this.list.filter((combo) => {
        return combo.billNum === this.currBillNum;
      });
      return this.dict.ComboGradeList.map((grade) => {
        return {
          list: comboList
            .filter((combo) => {
              return grade.value === combo.comboGrade;
            })
            .map((combo) => {
              combo.index = ++count;
              return combo;
            }),
          grade,
        };
      }).filter((grade) => {
        return grade.list.length > 0;
      });
    },
  },
  watch: {
    "searchData.comboType"() {
      this.getList();
    },
    "searchData.comboRoute"() {
      this.getList();
    },
  },
  methods: {
    getGradeGroupStyle(gradeValue, index) {
      const color = this.dict.ComboGradeToColorMap.get(gradeValue) || "#f5f5f5";
      // 将颜色转换为 rgba，降低透明度作为背景
      const rgbaColor = this.hexToRgba(color, 0.08);
      return {
        backgroundColor: rgbaColor,
      };
    },
    getGradeNameStyle(gradeValue) {
      const color = this.dict.ComboGradeToColorMap.get(gradeValue) || "#409EFF";
      return {
        backgroundColor: color,
        color: "#ffffff",
      };
    },
    hexToRgba(hex, alpha = 1) {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    onCheckedChange(id) {
      this.form.comboId = id;
    },
    afterOpen() {
      this.$set(this, "searchData", this.$options.data().searchData);
      this.$set(this, "form", this.$options.data().form);
      this.form.comboId = this.comboId;
      this.searchData.comboRoute = this.comboRoute;
      this.getList();
    },
    async getList() {
      this.list = await getStoreComboList({
        orderNo: this.orderNo,
        comboRoute: this.searchData.comboType === this.dict.EnumComboType.COMMON
            ? this.searchData.comboRoute : undefined,
        comboTab: this.searchData.comboType,
      });
      const existComboId = this.list.find(
        (item) => item.comboId === this.comboId,
      );
      if (!existComboId) {
        this.form.comboId = null;
      } else {
        this.form.comboId = this.comboId;
      }
      this.currBillNum = undefined;
      const billNumSet = new Set();
      this.list.map(item => billNumSet.add(item.billNum));
      this.billNumList = Array.from(billNumSet).sort((a, b) => a - b);
    },
    onClose() {
      this.$emit("update:visible", false);
    },
    async onSubmit() {
      const combo = this.list.find(
        (item) => item.comboId === this.form.comboId,
      );
      if (!combo) {
        this.$message.error("请选择方案");
        return;
      }
      await this.$confirm(
        `是否确认 <strong>${combo.comboName}</strong> 为新方案？`,
        {
          dangerouslyUseHTMLString: true,
        },
      );
      await editStoreComboList({
        orderNo: this.orderNo,
        comboTab: this.searchData.comboType,
        comboId: this.form.comboId,
        remark: this.searchData.comboType === EnumComboType.CUSTOM ? this.form.remark : null,
      });
      this.$message({
        type: "success",
        message: "操作成功",
      });
      this.onClose();
      this.$emit("refresh");
    },
  },
};
</script>

<style scoped lang="scss">
.combo-dialog {
  ::v-deep {
    .el-dialog {
      margin-bottom: 0 !important;
      border-radius: 16px;
      overflow: hidden;
    }
    
    .el-dialog__header {
      background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
      padding: 20px 24px;
      margin: 0;
      
      .el-dialog__title {
        color: #ffffff;
        font-size: 18px;
        font-weight: 600;
      }
      
      .el-dialog__close {
        color: #ffffff !important;
        font-size: 24px !important;
        font-weight: 600 !important;
        width: 36px !important;
        height: 36px !important;
        line-height: 36px !important;
        text-align: center !important;
        border-radius: 50% !important;
        background: rgba(0, 0, 0, 0.2) !important;
        transition: all 0.3s ease !important;
        opacity: 1 !important;
        
        &:hover {
          color: #ffffff !important;
          background: rgba(0, 0, 0, 0.3) !important;
          transform: scale(1.1) !important;
        }
        
        &:active {
          transform: scale(0.95) !important;
        }
      }
    }
    
    .el-dialog__body {
      padding: 24px;
      background: #f5f7fa;
    }
  }
}

.search-header {
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 20px;
  
  .combo-type-radio {
    ::v-deep .el-radio-button {
      margin-right: 12px;
      
      &:last-child {
        margin-right: 0;
      }
      
      .el-radio-button__inner {
        border-radius: 8px;
        border: 1.5px solid #e4e7ed;
        padding: 10px 20px;
        font-weight: 500;
        transition: all 0.3s ease;
        
        &:hover {
          border-color: #409EFF;
          color: #409EFF;
        }
      }
      
      &.is-active {
        .el-radio-button__inner {
          background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
          border-color: #409EFF;
          color: #ffffff;
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
        }
      }
    }
  }
  
  .period-select {
    display: flex;
    align-items: center;
    gap: 12px;
    
    .period-label {
      font-size: 14px;
      font-weight: 500;
      color: #606266;
      white-space: nowrap;
    }
    
    .period-select-input {
      width: 180px;
      
      ::v-deep .el-input__inner {
        border-radius: 8px;
        border: 1.5px solid #e4e7ed;
        transition: all 0.3s ease;
        
        &:hover {
          border-color: #c0c4cc;
        }
        
        &:focus {
          border-color: #409EFF;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
        }
      }
    }
  }
}

.combo-body {
  display: flex;
  flex-direction: column;
  margin-top: 0;
  max-height: calc(100vh - 5vh - 240px);
  
  .grade-list {
    display: flex;
    flex-direction: column;
    gap: 24px;
    overflow-y: auto;
    flex: 1;
    max-height: 100%;
    padding-right: 8px;
    
    &::-webkit-scrollbar {
      width: 8px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f5f7fa;
      border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #c0c4cc;
      border-radius: 4px;
      
      &:hover {
        background: #a8abb2;
      }
    }
  }
  
  .custom-form {
    margin-top: 24px;
    padding: 20px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    
    .remark-input {
      width: 400px;
      
      ::v-deep .el-input__inner {
        border-radius: 8px;
        border: 1.5px solid #e4e7ed;
        transition: all 0.3s ease;
        
        &:hover {
          border-color: #c0c4cc;
        }
        
        &:focus {
          border-color: #409EFF;
          box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
        }
      }
    }
  }
}

.grade-group {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 20px;
  border-radius: 12px;
  transition: all 0.3s ease;
  position: relative;
  
  .grade-name {
    font-size: 14px;
    font-weight: 600;
    border-radius: 8px;
    padding: 10px 20px;
    min-width: 80px;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    flex-shrink: 0;
  }

  .combo-list {
    position: relative;
    flex: 1;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
    background: transparent;
    padding: 0;
    width: 100%;

    .divider {
      position: absolute;
      top: -12px;
      left: 0;
      width: 100%;
      height: 2px;
      border: none;
      z-index: 1;
    }
  }
}

.dialog-save {
  position: absolute;
  right: 40px;
  top: 110px;
  z-index: 10;
  
  .save-btn {
    background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
    border: none;
    border-radius: 8px;
    padding: 10px 24px;
    font-weight: 600;
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.35);
    transition: all 0.3s ease;
    
    &:hover {
      background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
      box-shadow: 0 6px 16px rgba(64, 158, 255, 0.45);
      transform: translateY(-2px);
    }
    
    &:active {
      transform: translateY(0);
    }
  }
}

// 响应式设计
@media (max-width: 1400px) {
  .combo-body {
    .grade-list {
      .grade-group {
        .combo-list {
          grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .combo-body {
    .grade-list {
      .grade-group {
        .combo-list {
          grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .search-header {
    flex-direction: column;
    align-items: stretch;
    
    .period-select {
      width: 100%;
      
      .period-select-input {
        flex: 1;
      }
    }
  }
  
  .combo-body {
    .grade-list {
      .grade-group {
        flex-direction: column;
        
        .grade-name {
          width: 100%;
        }
        
        .combo-list {
          grid-template-columns: 1fr;
        }
      }
    }
  }
  
  .dialog-save {
    position: static;
    margin-top: 16px;
    text-align: right;
  }
}
</style>
